import NotificationService from "services/notification";
import NavigationService from "services/navigation";
import api from "services/api";

class ApplicationService {
  logout = async () => {
    await NotificationService.removeToken();
    localStorage.removeItem("token");
    NavigationService.navigate("/");
  };

  login = async ({ email, password }) => {
    try {
      const res = await api.signIn({ email, password });

      localStorage.setItem("token", res.data.token);
      NavigationService.navigate("/chats");
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  };
}

export default new ApplicationService();
